import tiket from './tiket'

export default [
  ...tiket,
]
